import React, { useEffect, useState } from 'react';
import axios from 'axios';

import Aos from 'aos';
import 'aos/dist/aos.css';
import { Link, useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

const Home = () => {
  useEffect(function () {
    Aos.init({ disable: 'mobile' });
  }, []);

  const location = useLocation();

  const [totalSupply, setTotalSupply] = useState<number | null>(null);
  const [currentPrice, setCurrentPrice] = useState<number | null>(null);
  const [marketCap, setMarketCap] = useState<string | null>(null);

  useEffect(() => {
    const fetchCoinData = async () => {
      try {
        // Fetching the total supply
        const totalSupplyResponse = await axios.get(
          'https://api.coingecko.com/api/v3/coins/novadex',
        );
        const totalSupplyData = totalSupplyResponse.data;
        console.error(totalSupplyResponse);
        setTotalSupply(totalSupplyData.market_data.total_supply);

        // Fetching the current price
        const priceResponse = await axios.get(
          'https://api.coingecko.com/api/v3/simple/price?ids=novadex&vs_currencies=usd',
        );
        const priceData = priceResponse.data;
        setCurrentPrice(priceData.novadex.usd);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchCoinData();

    // axios.get('https://api.coingecko.com/api/v3/coins/novadex')
    // .then(res => {
    //   // setData(res.data);
    //   console.error(res);
    // })
    // .catch(err => {
    //   console.error(err);
    // });
  }, []);

  useEffect(() => {
    if (totalSupply !== null && currentPrice !== null) {
      let marketCapValue = totalSupply * currentPrice;
      let formattedMarketCap: string;

      if (marketCapValue >= 1e9) {
        formattedMarketCap = (marketCapValue / 1e9).toFixed(2) + 'B';
      } else if (marketCapValue >= 1e6) {
        formattedMarketCap = (marketCapValue / 1e6).toFixed(2) + 'M';
      } else if (marketCapValue >= 1e3) {
        formattedMarketCap = (marketCapValue / 1e3).toFixed(2) + 'K';
      } else {
        formattedMarketCap = marketCapValue.toFixed(2);
      }

      setMarketCap(formattedMarketCap);
    }
  }, [totalSupply, currentPrice]);

  return (
    <>
      {/* Banner */}
      <div className="top-banner pb-5">
        <section className="banner" id="home">
          <div className="container py-lg-5">
            <div className="row">
              <div className="col-md-5 mb-md-0 mb-5 order-md-0 order-1">
                <h1
                  className="lp"
                  data-aos="fade-right"
                  data-aos-duration="800"
                >
                  DeFi trading made easy
                </h1>
                <p
                  className="pt-4 lp"
                  data-aos="fade-right"
                  data-aos-duration="1200"
                >
                  Earn yield through fees and yield farms, provide liquidity,
                  and trade any SPL token on NovaDEX
                </p>
                <div
                  className="lp pt-4"
                  data-aos="fade-right"
                  data-aos-duration="1500"
                >
                  <div className="d-flex gap-2 mb-lg-5 mb-4">
                    <a
                      href="https://jup.ag/swap/SOL-GtMtXoJiqSf8Gfp83cuunnDTiJTeTmv7cniVtJ6UAMWH"
                      target={'_blank'}
                      className="gap-2 btn-1"
                      rel="noreferrer"
                      onClick={() => {
                        ReactGA.event({
                          category: 'click',
                          action: 'Buy on Jupiter link clicked',
                        });
                      }}
                    >
                      Buy on <img src="assets/jupiter.svg" alt="" /> Jupiter
                    </a>
                    <a
                      href="https://www.mexc.com/exchange/NVX_USDT"
                      target={'_blank'}
                      rel="noreferrer"
                      className="gap-2 btn-2"
                      onClick={() => {
                        ReactGA.event({
                          category: 'click',
                          action: 'Buy on MEXC link clicked',
                        });
                      }}
                    >
                      Buy on <img src="assets/mex.svg" alt="" /> MEXC
                    </a>
                   
                  </div>
                  <div className="">
                    <a href="javascript:void(0)">
                      <img src="assets/solana.svg" height={30} alt="" />
                    </a>
                  </div>
                </div>
              </div>
              <div
                className="col-md-7 ps-lg-5 px-4"
                data-aos="fade-left"
                data-aos-duration="2000"
              >
                <img src="assets/banner.png" className="w-100" alt="" />
              </div>
            </div>
          </div>
        </section>

        <section className="mb-5 pb-lg-5">
          <div className="container">
          <div className="partner-list">
              <div className="scroll-x">
                <div
                  className="d-flex flex-wrap align-items-center pt-lg-3"
                  data-aos="fade-up"
                  data-aos-duration="1500"
                >
                  <h3 className="col-20">Featured in</h3>
                  <div className="col-20 text-center">
                      <img src="assets/fr6.png" className="w-100" alt="" />
                  </div>
                  <div className="col-20 text-center">
                    
                      <img src="assets/fr7.png" className="w-100" alt="" />
                  </div>
                  <div className="col-20 text-center">
                    
                      <img src="assets/fr8.png" className="w-100" alt="" />
                  </div>
                  <div className="col-20 text-center">
                    
                      <img src="assets/fr9.png" className="w-100" alt="" />
                  </div>
                  <div className="col-20 text-center">
                    
                      <img src="assets/fr10.png" className="w-100" alt="" />
                  </div>
                </div>
              </div>
            </div>
            <div className="partner-list mb-3 mb-md-0">
              <div className="scroll-x">
                <div
                  className="d-flex flex-wrap align-items-center pt-lg-3"
                  data-aos="fade-up"
                  data-aos-duration="1300"
                >
                  <h3 className="col-20 opacity-0 d-md-block d-none">Listed on</h3>
                  <div className="col-20 text-center">
                    <svg width="100%"  fill="white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 168 29"><path d="M28.442 14.445v-.056C28.414 6.466 22.032 0 14.221 0S0 6.466 0 14.445c0 7.98 6.381 14.433 14.221 14.433a13.978 13.978 0 0 0 9.66-3.866 1.309 1.309 0 0 0-1.766-1.933l-.028.028a11.5 11.5 0 0 1-16.572-.755l6.075-9.742v4.508c0 2.154.84 2.855 1.546 3.051.706.196 1.765.054 2.912-1.765l3.333-5.412c.089-.158.192-.308.306-.449v2.745c0 2.015.812 3.639 2.211 4.422a4.071 4.071 0 0 0 4.173-.167c1.616-1.049 2.484-2.886 2.371-5.098Zm-3.696 2.835a1.529 1.529 0 0 1-1.546.111c-.56-.335-.897-1.09-.897-2.126v-3.173c0-1.51-.588-2.603-1.595-2.881-1.709-.516-2.995 1.595-3.472 2.379l-3.015 4.842V10.47c-.028-1.371-.477-2.183-1.317-2.436-.56-.167-1.4-.082-2.211 1.15L3.946 19.989a11.971 11.971 0 0 1-1.371-5.544c0-6.523 5.234-11.814 11.646-11.814 6.412 0 11.646 5.291 11.646 11.814v.057c.067 1.258-.337 2.268-1.12 2.77v.008ZM48.263 9.518a1.407 1.407 0 0 1 .645 1.092 1.24 1.24 0 0 1-1.204 1.232 2.062 2.062 0 0 1-.449-.085 4.61 4.61 0 0 0-2.716-.922c-2.379 0-4.002 1.93-4.002 4.337s1.652 4.312 4.002 4.312a4.34 4.34 0 0 0 3.023-1.232c.206-.145.45-.223.701-.224a1.134 1.134 0 0 1 .99 1.709c-.097.17-.235.315-.402.42a6.647 6.647 0 1 1-4.283-11.758c1.318-.02 2.61.37 3.695 1.119ZM54.925 12.309a4.745 4.745 0 0 0-4.765 4.71 4.82 4.82 0 0 0 4.76 4.79c2.464 0 4.564-2.212 4.564-4.79 0-2.576-2.067-4.71-4.559-4.71Zm-.028 7.167c-1.175 0-2.155-1.064-2.155-2.436 0-1.427.98-2.296 2.155-2.296 1.093 0 2.015.897 2.015 2.296 0 1.4-.922 2.444-2.015 2.444v-.008ZM61.056 20.352v-6.608a1.29 1.29 0 0 1 1.289-1.314 1.306 1.306 0 0 1 1.289 1.314v6.608a1.306 1.306 0 0 1-1.289 1.315 1.328 1.328 0 0 1-1.289-1.315ZM60.86 9.938a1.505 1.505 0 0 1 1.485-1.547 1.528 1.528 0 0 1 1.51 1.547 1.497 1.497 0 0 1-2.994 0ZM68.559 16.77v3.582a1.289 1.289 0 1 1-2.578 0v-6.915a.994.994 0 1 1 1.988 0 3.738 3.738 0 0 1 2.835-1.12c2.577 0 3.724 1.932 3.724 4.144v3.891a1.289 1.289 0 1 1-2.578 0V16.77c0-1.121-.139-2.062-1.763-2.062-1.146 0-1.623.951-1.623 2.062h-.005ZM82.865 18.141a.835.835 0 0 1-.673-.338l-2.995-3.247v5.796a1.289 1.289 0 1 1-2.577 0V8.873a.546.546 0 0 1 .477-.335.9.9 0 0 1 .56.335l4.788 5.376a.624.624 0 0 0 .42.258.701.701 0 0 0 .42-.258l4.786-5.376a.843.843 0 0 1 .559-.335.49.49 0 0 1 .477.335v11.48a1.29 1.29 0 0 1-1.289 1.314 1.307 1.307 0 0 1-1.288-1.315v-5.796l-2.998 3.247a1.031 1.031 0 0 1-.67.338h.003ZM107.08 14.698h-.281c-1.623.082-1.93 1.008-1.93 2.062v3.582a1.29 1.29 0 0 1-1.289 1.289 1.29 1.29 0 0 1-1.288-1.29v-6.903a.997.997 0 0 1 .995-.995.996.996 0 0 1 .994.995c.951-.897 1.735-1.093 2.518-1.122h.258a1.207 1.207 0 0 1 1.175 1.204 1.18 1.18 0 0 1-1.147 1.178h-.005ZM117.018 19.736c.118.185.186.397.196.616a1.346 1.346 0 0 1-1.289 1.289c-.446 0-.84-.338-1.147-.73l-2.966-3.448v2.86a1.288 1.288 0 0 1-2.577 0V9.828a1.287 1.287 0 0 1 2.199-.911c.242.241.378.57.378.91v6.55l2.966-3.274c.307-.337.673-.7 1.119-.7a1.289 1.289 0 0 1 1.232 1.26 1.09 1.09 0 0 1-.168.587l-2.35 2.577 2.407 2.913v-.003ZM132.584 21.78h-.701c-1.959 0-3.108-.869-3.108-3.92v-3.162h-.67a1.19 1.19 0 1 1 0-2.382h.66V9.881a1.282 1.282 0 0 1 .789-1.214c.158-.066.328-.1.499-.1a1.311 1.311 0 0 1 1.289 1.314v2.428h1.062a1.185 1.185 0 0 1 1.149 1.203 1.222 1.222 0 0 1-1.149 1.178h-1.062v2.66c0 1.763.082 2.126.866 2.126h.366a1.152 1.152 0 0 1 1.147 1.15 1.174 1.174 0 0 1-1.147 1.147l.01.007ZM145.04 9.518a1.41 1.41 0 0 1 .644 1.092 1.239 1.239 0 0 1-1.204 1.232 2.135 2.135 0 0 1-.448-.085 4.597 4.597 0 0 0-2.714-.922c-2.381 0-4.005 1.93-4.005 4.337s1.652 4.312 4.005 4.312a4.34 4.34 0 0 0 3.023-1.232c.205-.144.449-.222.699-.224a1.143 1.143 0 0 1 .816.332 1.134 1.134 0 0 1 .176 1.378 1.184 1.184 0 0 1-.405.418 6.639 6.639 0 0 1-5.978 1.3 6.642 6.642 0 0 1-4.853-7.268 6.642 6.642 0 0 1 6.548-5.789 6.27 6.27 0 0 1 3.696 1.119ZM98.99 12.402a.982.982 0 0 0-.982 1.007l-.054.31a4.026 4.026 0 0 0-2.997-1.428c-2.518 0-4.337 2.126-4.337 4.7 0 2.575 1.79 4.789 4.198 4.789 1.008 0 2.603-.449 3.108-1.428l.057.307a.964.964 0 0 0 1.007.982 1.006 1.006 0 0 0 1.008-1.008v-7.216a1.03 1.03 0 0 0-1.008-1.015Zm-3.752 7.082c-1.147 0-2.044-1.09-2.044-2.436 0-1.345.923-2.32 2.044-2.32 1.12 0 2.129.923 2.129 2.32 0 1.397-.982 2.436-2.13 2.436ZM126.425 16.824c-.057-2.884-1.933-4.508-4.423-4.508-3.092 0-4.397 2.24-4.397 4.817 0 3.276 2.158 4.675 4.761 4.675.979 0 2.015-.141 2.798-.729a1.135 1.135 0 0 0 .56-.923 1.057 1.057 0 0 0-1.031-1.064c-.237.002-.469.07-.67.196a4.173 4.173 0 0 1-1.681.335c-.644 0-2.128-.258-2.128-1.791h5.2a1.031 1.031 0 0 0 1.011-1.008Zm-6.217-.65c0-1.09 1.15-1.453 1.848-1.453.699 0 1.848.363 1.876 1.453h-3.724ZM155.31 12.402a.984.984 0 0 0-.703.296.976.976 0 0 0-.277.711l-.056.31a4.02 4.02 0 0 0-2.995-1.428c-2.52 0-4.34 2.126-4.34 4.7 0 2.575 1.804 4.789 4.198 4.789 1.008 0 2.606-.449 3.108-1.428l.057.307a.974.974 0 0 0 .292.708.965.965 0 0 0 .716.274 1.01 1.01 0 0 0 .932-.622c.05-.122.076-.253.076-.386v-7.216a1.032 1.032 0 0 0-1.008-1.015Zm-3.753 7.082c-1.118 0-2.043-1.09-2.043-2.436 0-1.345.897-2.32 2.043-2.32 1.147 0 2.129.923 2.129 2.32 0 1.397-.974 2.436-2.123 2.436h-.006ZM163.657 12.309a4.14 4.14 0 0 0-3.023 1.232c0-.642-.42-1.119-.979-1.119a1.007 1.007 0 0 0-1.01 1.008v10.863a1.291 1.291 0 0 0 1.288 1.288 1.29 1.29 0 0 0 1.289-1.288v-3.268c.698.53 1.819.755 2.577.773 2.436 0 4.201-2.211 4.201-4.788 0-2.578-1.85-4.701-4.343-4.701Zm-.309 7.167c-1.147 0-2.126-1.03-2.126-2.435s.979-2.32 2.126-2.32c1.147 0 2.044.923 2.044 2.32 0 1.352-.894 2.443-2.044 2.443v-.008Z"></path></svg>
                  </div>
                  <div className="col-20 text-center">
                    <img src="assets/fr2.svg" className="w-100" alt="" />
                  </div>
                  <div className="col-20 text-center">
                    <img src="assets/fr3.png" className="w-100" alt="" />
                  </div>
                  <div className="col-20 text-center">
                    <img src="assets/fr4.png" className="w-100" alt="" />
                  </div>
                  <div className="col-20 text-center">
                    <img src="assets/fr5.svg" className="w-sm-100" alt="" />
                  </div>
                </div>
              </div>
            </div>
            <div className="partner-list pt-lg-3">
              <div className="scroll-x">
                <div
                  className="d-flex flex-wrap align-items-center pt-lg-3"
                  data-aos="fade-up"
                  data-aos-duration="1500"
                >
                  <h3 className="col-20">Listed on</h3>
                  <div className="col-20 text-center">
                    <a
                      className="listed-link"
                      href="https://www.mexc.com/exchange/NVX_USDT"
                      target="_blank"
                      rel="noreferrer noopener"
                      onClick={() =>
                        ReactGA.event({
                          category: 'click',
                          action: 'Buy MEXC Click - Listed On',
                        })
                      }
                    >
                      <img src="assets/l1.png" className="w-100" alt="" />
                    </a>
                  </div>
                  {/* <div className="col-20 text-center">
                    <a
                      className="listed-link"
                      href="https://jup.ag/swap/SOL-NVX"
                      target="_blank"
                      rel="noreferrer noopener"
                      onClick={() =>
                        ReactGA.event({
                          category: 'click',
                          action: 'Buy Jupiter Click - Listed On',
                        })
                      }
                    >
                      <img src="assets/l2.png" className="w-100" alt="" />
                    </a>
                  </div>
                  <div className="col-20 text-center">
                    <a
                      className="listed-link"
                      href="https://www.bitmart.com/trade/en-US?symbol=NVX_USDT"
                      target="_blank"
                      rel="noreferrer noopener"
                      onClick={() =>
                        ReactGA.event({
                          category: 'click',
                          action: 'Buy Bitmart Click - Listed On',
                        })
                      }
                    >
                      <img src="assets/l3.svg" className="w-100" alt="" />
                    </a>
                  </div> */}
                  <div className="col-20 text-center">
                    <a
                      className="listed-link"
                      href="https://raydium.io/swap/?inputCurrency=sol&outputCurrency=GtMtXoJiqSf8Gfp83cuunnDTiJTeTmv7cniVtJ6UAMWH&fixed=in"
                      target="_blank"
                      rel="noreferrer noopener"
                      onClick={() =>
                        ReactGA.event({
                          category: 'click',
                          action: 'Buy Raydium Click - Listed On',
                        })
                      }
                    >
                      <img src="assets/l4.svg" className="w-sm-100" alt="" />
                    </a>
                  </div>
                  {/* <div className="col-20 text-center">
                    <a
                      className="listed-link"
                      href="https://www.orca.so/"
                      target="_blank"
                      rel="noreferrer noopener"
                      onClick={() =>
                        ReactGA.event({
                          category: 'click',
                          action: 'Buy ORCA Click - Listed On',
                        })
                      }
                    >
                      <img src="assets/l5.png" className="w-100" alt="" />
                    </a>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="mb-5 pb-lg-4">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center mb-4">
                <h2 data-aos="fade-up" data-aos-duration="1500">
                  Our metrics
                </h2>
              </div>
              <div className="col-md-4 mb-4">
                <div
                  className="metrics-box"
                  data-aos="fade-right"
                  data-aos-duration="1200"
                >
                  {marketCap && <h4>${marketCap}</h4>}
                  {/* <h4>758K</h4> */}
                  <p>MARKET CAP</p>
                </div>
              </div>
              <div
                className="col-md-4 mb-4"
                data-aos="fade-up"
                data-aos-duration="1300"
              >
                <div className="metrics-box">
                  <h4>30K+</h4>
                  <p>SOCIAL MEDIA FOLLOWERS</p>
                </div>
              </div>
              <div
                className="col-md-4 mb-4"
                data-aos="fade-left"
                data-aos-duration="1400"
              >
                <div className="metrics-box">
                  <h4>85K+</h4>
                  <p>TOTAL TRANSACTIONS</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="pt-md-5 mt-lg-4">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-5 mb-md-0 mb-4">
                <div
                  className="gc-box"
                  data-aos="fade-right"
                  data-aos-duration="1600"
                >
                  <h5>Governed by the community.</h5>
                  <p className="text-white">
                    The NovaDEX Protocol is managed by a global community of
                    DeFi enthusiasts.
                  </p>
                  <img src="assets/gc.png" className="w-100" alt="" />
                </div>
              </div>
              <div className="col-md-7">
                <div
                  className="metric-box mb-3"
                  data-aos="fade-up"
                  data-aos-duration="2000"
                >
                  <h4>Buy and Hold (DEX)</h4>
                  <p>
                    To buy on Solana, go to our DEX
                    and connect your Phantom or other Solana wallet. Swap SOL,
                    USDT, BONK or other to purchase $NVX tokens.{' '}
                  </p>
                </div>
                <div
                  className="metric-box mb-3"
                  data-aos="fade-up"
                  data-aos-duration="2200"
                >
                  <h4>Trade and Earn</h4>
                  <p>
                    Start Trading on NovaDEX and earn Novapoints. The more you
                    trade the bigger the airdrop you receive.
                    <a
                      href="https://medium.com/@NovaDEX.io/novadex-points-system-5962675ca363"
                      target={'_blank'}
                      rel="noreferrer"
                    >
                      {' '}
                      (<u>More info!</u>){' '}
                    </a>
                  </p>
                </div>
                <div
                  className="metric-box mb-3"
                  data-aos="fade-up"
                  data-aos-duration="2400"
                >
                  <h4>Receive Airdrop</h4>
                  <p>
                    At the end of the period, all traders will receive an
                    Airdrop according to their volume/liquidity provided.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-5 mt-lg-5">
          <div className="container" id="liquidity">
            <div className="work-card">
              <div className="work-box">
                <div className="row">
                  <div
                    className="col-md-12 text-center mb-4"
                    data-aos="fade-up"
                    data-aos-duration="1200"
                  >
                    <h2>How Concentrated Liquidity Works</h2>
                  </div>

                  <div className="col-md-6 ps-lg-5 mb-md-0 mb-5">
                    <h4 data-aos="fade-right" data-aos-duration="1200">
                      Active Liquidity Management
                    </h4>
                    <p data-aos="fade-right" data-aos-duration="1500">
                      A standout feature of NovaDEX is its pioneering concept of
                      Active Liquidity Management, an innovation available
                      exclusively within the Solana ecosystem. <br /> <br />
                      This dynamic mechanism empowers liquidity providers (LPs)
                      to seamlessly uphold their holdings within predetermined
                      price ranges, adeptly navigating the challenges posed by
                      market price fluctuations.
                    </p>
                    <a
                      href="https://app.novadex.io/"
                      target={'_blank'}
                      rel="noreferrer"
                      data-aos="fade-right"
                      data-aos-duration="1800"
                      className="primary-btn px-lg-5"
                    >
                      Provide Liquidity Today
                    </a>
                  </div>
                  <div className="col-md-6">
                    <img
                      src="assets/chart.png"
                      data-aos="fade-left"
                      data-aos-duration="1800"
                      className="w-100"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="benefits">
          <div className="container">
            <div className="row align-items-center">
              <div
                className="col-md-12 text-center mb-4"
                data-aos="fade-up"
                data-aos-duration="1200"
              >
                <h2>Liquidity Provider’s Benefits</h2>
              </div>
              <div
                className="col-md-6 mb-md-0 mb-5"
                data-aos="fade-right"
                data-aos-duration="1400"
              >
                <div className="scroll-list">
                  <div className="max-700">
                    <img src="assets/Lp.png" className="w-100" alt="" />
                  </div>
                </div>
                <div className="text-center mt-4">
                  <img src="assets/footer-logo.svg" alt="" />
                </div>
              </div>
              <div className="col-md-6">
                <small data-aos="fade-up" data-aos-duration="1300">
                  The Case for Concentrated Liquidity
                </small>
                <h4
                  className="fs-30 lh mb-4 mt-2"
                  data-aos="fade-up"
                  data-aos-duration="1400"
                >
                  Reasons to Trade and LP with NovaDEX
                </h4>

                <p
                  className="text-white fw-300"
                  data-aos="fade-up"
                  data-aos-duration="1500"
                >
                  In V3 DEX Models, LPs specify the price ranges in which their
                  liquidity will be used. This limits the exposure to the
                  desired price range, allowing more efficient capital
                  allocation and a potential for higher returns. There are
                  several benefits:
                </p>
                <p
                  className="text-white fw-300"
                  data-aos="fade-up"
                  data-aos-duration="1600"
                >
                  <b className="fw-600">Less slippage</b> <br /> By providing
                  liquidity in specific ranges, LPing becomes more capital
                  efficient as the liquidity is concentrated in narrower ranges
                  compared to the infinite spectrum in V2. This results in less
                  slippage when trading.
                </p>

                <p
                  className="fw-300 text-white"
                  data-aos="fade-up"
                  data-aos-duration="1700"
                >
                  <b className="fw-600">Increased Returns</b> <br /> A narrower
                  range means more assets available for trades and less
                  competition within that range, translating into collecting
                  more fees and potentially higher returns*. It’s not uncommon
                  to see 100%+ APRs in V3, but it doesn’t reflect the actual
                  returns.
                </p>

                <p
                  className="text-white fw-300"
                  data-aos="fade-up"
                  data-aos-duration="1800"
                >
                  <b className="fw-600">Flexible Risk Management</b>
                  <br /> LPs can manage their risk more efficiently by setting a
                  range that aligns with their risk tolerance and market view.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="container">
            <div className="row pb-5 pt-5">
              <div className="col-md-12 text-center mt-lg-5 mb-5">
                <h2 data-aos="fade-up" data-aos-duration="1300">
                  Why use NovaDEX?
                </h2>
                <p
                  className="mb-md-5 fs-24"
                  data-aos="fade-up"
                  data-aos-duration="1500"
                >
                  Get the best DeFi trading experience with NovaDEX
                </p>
              </div>

              <div className="col-md-4 mb-lg-5 mb-4 text-center">
                <div
                  className="feature-card"
                  data-aos="fade-up"
                  data-aos-duration="1300"
                >
                  <img src="assets/img1.svg" alt="" />
                  <h4>Create Pools</h4>
                  <p>
                    Users can permissionless create liquidity pool of their
                    choice on any token on NovaDEX
                  </p>
                </div>
              </div>

              <div className="col-md-4 mb-lg-5 mb-4 text-center">
                <div
                  className="feature-card"
                  data-aos="fade-up"
                  data-aos-duration="1500"
                >
                  <img src="assets/img2.svg" alt="" />
                  <h4>Fair pricing & returns</h4>
                  <p>
                    Best rates in the industry with the least slippage and earn
                    high juicy APR in your favourite pools
                  </p>
                </div>
              </div>

              <div className="col-md-4 mb-lg-5 mb-4 text-center">
                <div
                  className="feature-card"
                  data-aos="fade-up"
                  data-aos-duration="1700"
                >
                  <img src="assets/img3.svg" alt="" />
                  <h4>Hard-working liquidity</h4>
                  <p>
                    NovaDEX is a concentrated liquidity DEX that empowers users
                    to assign liquidity within a custom price range, offering
                    traders the ability to enhance their efficiency and minimize
                    slippage
                  </p>
                </div>
              </div>

              <div className="col-md-4 mb-lg-5 mb-4 text-center">
                <div
                  className="feature-card"
                  data-aos="fade-up"
                  data-aos-duration="1900"
                >
                  <img src="assets/img4.svg" alt="" />
                  <h4>Yield Farming</h4>
                  <p>
                    Yield Farming offers users the chance to accumulate rewards
                    by depositing liquidity provider (LP) tokens into Yield Farm
                    pools.
                  </p>
                </div>
              </div>

              <div className="col-md-4 mb-lg-5 mb-4 text-center">
                <div
                  className="feature-card"
                  data-aos="fade-up"
                  data-aos-duration="2100"
                >
                  <img src="assets/img5.svg" alt="" />
                  <h4>User Experience</h4>
                  <p>
                    NovaDEX makes it simple to engage in swapping, add liquidity
                    to pools, and earn impressive yields
                  </p>
                </div>
              </div>

              <div className="col-md-4 mb-lg-5 mb-4 text-center">
                <div
                  className="feature-card"
                  data-aos="fade-up"
                  data-aos-duration="2300"
                >
                  <img src="assets/img6.svg" alt="" />
                  <h4>Security</h4>
                  <p>
                    Security is our utmost priority for our team. Therefore, we
                    have conducted various audits by independent audit firms to
                    make NovaDEX safest platform to trade on Solana
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="container" id="testimonial">
            <div className="row">
              <div
                className="col-md-12 text-center mb-4"
                data-aos="fade-up"
                data-aos-duration="1300"
              >
                <h2>Testimonials from the Community</h2>
              </div>
              <div className="col-md-4 mb-4">
                <div
                  className="user-box"
                  data-aos="fade-up"
                  data-aos-duration="1500"
                >
                  <div className="mb-4">
                    <img src="assets/quote.svg" className="mb-4" alt="" />
                    <p>
                      Get it on the Absolutely blown away by the seamless
                      experience provided by NovaDEX. Transactions are fast and
                      smooth. Proud to be a part of this innovative community!
                    </p>
                  </div>
                  <div className="user">
                    <div className="user-img">
                      <img src="assets/user.png" alt="" />
                    </div>
                    <div className="user-detail">
                      <p className="mb-1">Salmon</p>
                      <p className="mb-0">@krypto24seven</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-4 mb-4">
                <div
                  className="user-box"
                  data-aos="fade-up"
                  data-aos-duration="2000"
                >
                  <div className="mb-4">
                    <img src="assets/quote.svg" className="mb-4" alt="" />
                    <p>
                      Simple intuitive design. Great points program. Love it.
                    </p>
                  </div>
                  <div className="user">
                    <div className="user-img">
                      <img src="assets/user1.png" alt="" />
                    </div>
                    <div className="user-detail">
                      <p className="mb-1">cryptotrader.web3.0</p>
                      <p className="mb-0">@dipanjangh</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-4 mb-4">
                <div
                  className="user-box"
                  data-aos="fade-up"
                  data-aos-duration="2500"
                >
                  <div className="mb-4">
                    <img src="assets/quote.svg" className="mb-4" alt="" />
                    <p>
                      NovaDEX has lightning-fast trading, fair pricing, and
                      hard-working liquidity that redefine decentralized
                      trading. I shape my DeFi journey with the best rates,
                      minimal slippage, and a seamless user experience. It's the
                      future of decentralized exchanges.
                    </p>
                  </div>
                  <div className="user">
                    <div className="user-img">
                      <img src="assets/user2.png" alt="" />
                    </div>
                    <div className="user-detail">
                      <p className="mb-1">samukapsilva.eth</p>
                      <p className="mb-0">@samukapsilva</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="py-5">
          <div className="container">
            <div className="bg-box" data-aos="fade-up" data-aos-duration="1400">
              <h2>A One-Stop DeFi Solution</h2>
              <p>
                NovaDEX aspires to be the go-to DeFi project on Solana, serving
                as a comprehensive utility to fulfill all users' DeFi needs. Its
                product suite includes a Standard AMM, Concentrated Liquidity
                AMM, Spot Trading, Yield Farming and the unique advantage of
                Incentivized Trading Based on NovaPoints.
              </p>
            </div>
          </div>
        </section>

        <section className="py-lg-5">
          <div className="container">
            <div className="row">
              <div className="col-md-4 mb-4">
                <div
                  className="os-card"
                  data-aos="fade-up"
                  data-aos-duration="1500"
                >
                  <div className="mb-3">
                    <img src="assets/os1.svg" className="mb-4" alt="" />
                    <h3>Active Liquidity Management</h3>
                  </div>
                  <p>
                    NovaDEXs innovative approach, underpinned by Concentrated
                    Liquidity and Active Liquidity Management, marks a turning
                    point in DEX platforms.
                  </p>
                </div>
              </div>

              <div className="col-md-4 mb-4">
                <div
                  className="os-card"
                  data-aos="fade-up"
                  data-aos-duration="1700"
                >
                  <div className="mb-3">
                    <img src="assets/os2.svg" className="mb-4" alt="" />
                    <h3>Decentralized Governance for Community Empowerment</h3>
                  </div>
                  <p>
                    Central to its philosophy is a robust, decentralized
                    governance model that empowers users to directly influence
                    pivotal decisions regarding the platform's evolution.
                  </p>
                </div>
              </div>

              <div className="col-md-4 mb-4">
                <div
                  className="os-card"
                  data-aos="fade-up"
                  data-aos-duration="1900"
                >
                  <div className="mb-3">
                    <img src="assets/os3.svg" className="mb-4" alt="" />
                    <h3>High Security Standards</h3>
                  </div>
                  <p>
                    Security is paramount within the DeFi ecosystem.
                    Demonstrating its unwavering commitment, the platform has
                    undergone a meticulous audit by esteemed crypto firm
                    QuillAudits, a testament to its dedication to the highest
                    security standards.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="feature-bg pb-md-5 mb-lg-4">
          <div className="container pt-lg-5 mt-lg-5" id="features">
            <div className="row pt-5 pb-4 mb-lg-5">
              <div className="col-md-12 text-center">
                <h2 data-aos="fade-up" data-aos-duration="1300">
                  Our Features
                </h2>
                <p
                  className="mb-5 fs-24"
                  data-aos="fade-up"
                  data-aos-duration="1500"
                >
                  NovaDEX revolutionizes crypto trading for all
                </p>
              </div>

              <div className="col-md-4 mb-md-0 mb-4 text-center">
                <div
                  className="d-flex flex-column justify-content-between h-100"
                  data-aos="fade-up"
                  data-aos-duration="1600"
                >
                  <div>
                    <img src="assets/f1.png" className="w-100" alt="" />
                    <h4 className="mt-3 mt-md-0">Trade</h4>
                    <p>Start trading today with minimal slippage.</p>
                  </div>
                  <div>
                    <a
                      href="https://app.novadex.io/"
                      target={'_blank'}
                      className="primary-btn-outline"
                    >
                      Enter Exchange
                    </a>
                  </div>
                </div>
              </div>

              <div className="col-md-4 mb-md-0 mb-4 text-center">
                <div
                  className="d-flex flex-column justify-content-between h-100"
                  data-aos="fade-up"
                  data-aos-duration="2000"
                >
                  <div>
                    <img src="assets/f2.png" className="w-100" alt="" />
                    <h4 className="mt-3 mt-md-0">Yield</h4>
                    <p>Earn yield through fees and yield farms</p>
                  </div>
                  <div>
                    <a
                      href="https://app.novadex.io/"
                      target={'_blank'}
                      className="primary-btn-outline"
                    >
                      Enter Farms
                    </a>
                  </div>
                </div>
              </div>

              <div className="col-md-4 mb-md-0 mb-4 text-center">
                <div
                  className="d-flex flex-column justify-content-between h-100"
                  data-aos="fade-up"
                  data-aos-duration="2400"
                >
                  <div>
                    <img src="assets/f3.png" className="w-100" alt="" />
                    <h4 className="mt-3 mt-md-0">Pool</h4>
                    <p>Provide liquidity for any SPL token</p>
                  </div>
                  <div>
                    <a
                      href="https://app.novadex.io/"
                      target={'_blank'}
                      className="primary-btn-outline"
                    >
                      Enter Exchange
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="pb-5 pt-lg-5" id="roadmap">
          <div className="container">
            <div className="row pt-5">
              <div
                className="col-md-12 text-center mb-4"
                data-aos="fade-up"
                data-aos-duration="1200"
              >
                <h2>ROADMAP</h2>
              </div>
              <div className="col-md-4 mb-4">
                <div
                  className="map-card"
                  data-aos="fade-right"
                  data-aos-duration="1600"
                >
                  <h4>Phase 1</h4>
                  <ul>
                    <li>Website Launch</li>
                    <li>Research and Development</li>
                    <li>Testnet Campaign</li>
                    <li>Community Building</li>
                    <li>Alpha Release</li>
                  </ul>
                </div>
              </div>

              <div className="col-md-4 mb-4">
                <div
                  className="map-card"
                  data-aos="fade-up"
                  data-aos-duration="1800"
                >
                  <h4>Phase 2</h4>
                  <ul>
                    <li>Token Deployment</li>
                    <li>Token Launch</li>
                    <li>Mainnet Launch</li>
                    <li>DEX Listings</li>
                    <li>CEX Listings</li>
                  </ul>
                </div>
              </div>

              <div className="col-md-4 mb-4">
                <div
                  className="map-card"
                  data-aos="fade-left"
                  data-aos-duration="2000"
                >
                  <h4>Phase 3</h4>
                  <ul>
                    <li>NovaPoints Program</li>
                    <li>Airdrop Launch</li>
                    <li>Community Growth</li>
                    <li>Marketing Initiatives</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <section className="buy py-lg-5" id="buy">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <h2
                  className="mb-4"
                  data-aos="fade-up"
                  data-aos-duration="1200"
                >
                  How to buy
                </h2>
                <div
                  className="mb-4 mb-lg-5"
                  data-aos="fade-right"
                  data-aos-duration="1400"
                >
                  <div className="d-flex align-items-center gap-3 mb-3">
                    <img src="assets/1.svg" alt="" />
                    <h4 className="lh">Buy and Hold (DEX)</h4>
                  </div>
                  <p className="text-white fw-300">
                    To buy on Solana, go to Birdeye
                    <a
                      href="https://birdeye.so/token/GtMtXoJiqSf8Gfp83cuunnDTiJTeTmv7cniVtJ6UAMWH?chain=solana"
                      target={'_blank'}
                      rel="noreferrer"
                    >
                      {' '}
                      (<u>click here!</u>){' '}
                    </a>
                    and connect your Phantom or other Solana wallet. Swap SOL,
                    USDT, BONK or other to purchase $NVX.
                  </p>
                </div>

                <div
                  className="mb-4 mb-lg-5"
                  data-aos="fade-right"
                  data-aos-duration="1600"
                >
                  <div className="d-flex align-items-center gap-3 mb-3">
                    <img src="assets/2.svg" alt="" />
                    <h4 className="lh">Buy and Hold (CEX)</h4>
                  </div>
                  <p className="text-white fw-300">
                    To buy on CEX, you can either sign up at MEXC or Bitmart and
                    purchase $NVX at those venues.
                  </p>
                </div>

                <div
                  className="mb-4 mb-lg-5"
                  data-aos="fade-right"
                  data-aos-duration="1800"
                >
                  <div className="d-flex align-items-center gap-3 mb-3">
                    <img src="assets/3.svg" alt="" />
                    <h4 className="lh">Trade and Earn</h4>
                  </div>
                  <p className="text-white fw-300">
                    Start Trading and Providing Liquidity on our Platform and
                    start receiving NovaPoints. The more NovaPoints you have,
                    the bigger Airdrop you get.
                  </p>
                </div>
              </div>
              <div className="col-md-6 d-md-block d-none">
                <img
                  src="assets/buy.png"
                  data-aos="fade-left"
                  data-aos-duration="1600"
                  className="w-100"
                  alt=""
                />
              </div>
            </div>
          </div>
        </section> */}

        <section>
          <div className="container">
            <div className="com-box">
              <div className="row">
                <div className="col-md-12 mb-4 text-center">
                  <h2 data-aos="fade-up" data-aos-duration="1200">
                    Join our Community
                  </h2>
                  <p data-aos="fade-up" data-aos-duration="1500">
                    Together we can make the NovaDEX community even stronger
                  </p>
                </div>
                <div className="col-md-4 mb-4">
                  <div
                    className="metrics-box h-100"
                    data-aos="fade-right"
                    data-aos-duration="1400"
                  >
                    <div className="d-flex align-items-center gap-2 mb-4">
                      <img src="assets/xr.svg" alt="" />
                      <p className="fw-300">Twitter Followers</p>
                    </div>
                    <h4 className="mb-0">30K+</h4>
                  </div>
                </div>
                <div className="col-md-4 mb-4">
                  <div
                    className="metrics-box h-100"
                    data-aos="fade-up"
                    data-aos-duration="1600"
                  >
                    <div className="d-flex align-items-center gap-2 mb-4">
                      <img src="assets/dr.svg" alt="" />
                      <p className="fw-300">Discord Members</p>
                    </div>
                    <h4 className="mb-0">52K+</h4>
                  </div>
                </div>
                <div className="col-md-4 mb-md-4">
                  <div
                    className="metrics-box h-100 "
                    data-aos="fade-left"
                    data-aos-duration="1800"
                  >
                    <div className="d-flex align-items-center gap-2 mb-4">
                      <img src="assets/zr.svg" alt="" />
                      <p className="fw-300">Zealy Members</p>
                    </div>
                    <h4 className="mb-0">61K+</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="my-5 pt-lg-5">
          <div className="container">
            <div className="partner-list">
              <h3
                data-aos="fade-up"
                className="text-md-start text-center mb-lg-0 mb-3"
                data-aos-duration="1300"
              >
                Our Partners
              </h3>
              <div
                className="d-flex flex-wrap justify-content-center align-items-center pt-lg-3 partners"
                data-aos="fade-up"
                data-aos-duration="1500"
              >
                <div className="col-20 text-center mb-4">
                  <img src="assets/op1.svg" className="w-sm-100 w-sm" alt="" />
                </div>
                <div className="col-20 text-center mb-4">
                  <img src="assets/op2.svg" className="w-sm-100 w-sm" alt="" />
                </div>
                <div className="col-20 text-center mb-4">
                  <img src="assets/op3.svg" className="w-sm-100" alt="" />
                </div>
                <div className="col-20 text-center mb-4">
                  <img src="assets/op4.svg" className="w-sm-100" alt="" />
                </div>
                <div className="col-20 text-center mb-4">
                  <img
                    src="assets/op5.svg"
                    className="w-sm-100"
                    alt=""
                    height={45}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="container">
            <div className="row justify-content-center">
              <div
                className="col-md-12 text-center mb-4"
                data-aos="fade-up"
                data-aos-duration="1200"
              >
                <h2>Traders Leaderboard</h2>
              </div>

              <div className="col-md-10">
                <div className="scroll-list">
                  <div className="max-700">
                    <img
                      src="assets/TL.png"
                      data-aos="fade-up"
                      data-aos-duration="1600"
                      className="w-100"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="faq">
          <div className="container">
            <div className="row justify-content-center py-5 my-lg-5">
              <div className="col-md-10">
                <h2
                  className="text-center"
                  data-aos="fade-up"
                  data-aos-duration="1200"
                >
                  FAQ
                </h2>

                <div className="box-faq">
                  <div className="accordion" id="accordionExample">
                    <div
                      className="accordion-item"
                      data-aos="fade-up"
                      data-aos-duration="1300"
                    >
                      <h3 className="accordion-header" id="headingOne">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseOne"
                          aria-expanded="false"
                          aria-controls="collapseOne"
                        >
                          What is NovaDEX?
                        </button>
                      </h3>
                      <div
                        id="collapseOne"
                        className="accordion-collapse collapse"
                        aria-labelledby="headingOne"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          NovaDEX aspires to be the go-to DeFi project on
                          Solana, serving as a comprehensive utility to fulfill
                          all users' DeFi needs. Its product suite includes a
                          Standard AMM, Concentrated Liquidity AMM, Spot
                          Trading, Yield Farming and the unique advantage of
                          Incentivized Trading Based on NovaPoints.
                        </div>
                      </div>
                    </div>

                    <div
                      className="accordion-item"
                      data-aos="fade-up"
                      data-aos-duration="1500"
                    >
                      <h3 className="accordion-header" id="heading2">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse2"
                          aria-expanded="false"
                          aria-controls="collapse2"
                        >
                          Is NovaDEX audited?
                        </button>
                      </h3>
                      <div
                        id="collapse2"
                        className="accordion-collapse collapse"
                        aria-labelledby="heading2"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          As the NovaDEX team, we are committed to providing
                          maximum security and transparency. NovaDEX has been
                          successfully audited by QuillAudits. Our audit results
                          are published in our docs.
                        </div>
                      </div>
                    </div>

                    <div
                      className="accordion-item"
                      data-aos="fade-up"
                      data-aos-duration="1500"
                    >
                      <h3 className="accordion-header" id="heading3">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse3"
                          aria-expanded="false"
                          aria-controls="collapse3"
                        >
                          Is NovaDEX listed on a CEX?
                        </button>
                      </h3>
                      <div
                        id="collapse3"
                        className="accordion-collapse collapse"
                        aria-labelledby="heading3"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          Yes, NovaDEX ($NVX) is currently trading at MEXC
                        </div>
                      </div>
                    </div>

                    <div
                      className="accordion-item"
                      data-aos="fade-up"
                      data-aos-duration="1600"
                    >
                      <h3 className="accordion-header" id="heading4">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse4"
                          aria-expanded="false"
                          aria-controls="collapse4"
                        >
                          Can you explain Concentrated Liquidity?
                        </button>
                      </h3>
                      <div
                        id="collapse4"
                        className="accordion-collapse collapse"
                        aria-labelledby="heading4"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          A standout feature of NovaDEX is its pioneering
                          concept of Active Liquidity Management, an innovation
                          available exclusively within the Solana ecosystem.
                          This dynamic mechanism empowers liquidity providers
                          (LPs) to seamlessly uphold their holdings within
                          predetermined price ranges, adeptly navigating the
                          challenges posed by market price fluctuations.
                        </div>
                      </div>
                    </div>

                    <div
                      className="accordion-item"
                      data-aos="fade-up"
                      data-aos-duration="1700"
                    >
                      <h3 className="accordion-header" id="heading5">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse5"
                          aria-expanded="false"
                          aria-controls="collapse5"
                        >
                          Why did you build on Solana?
                        </button>
                      </h3>
                      <div
                        id="collapse5"
                        className="accordion-collapse collapse"
                        aria-labelledby="heading5"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          At the core of Solana's appeal to developers is its
                          unique architecture, featuring a combination of Proof
                          of History (PoH) and Proof of Stake (PoS) consensus
                          mechanisms. PoH establishes a historical record of
                          transactions, enhancing the efficiency of the network,
                          while PoS ensures security and decentralization
                          <br />
                          <br />
                          On top of that we are super bullish on the Solana
                          Ecosystem and Community. We believe in great UX,
                          Ecosystem and Community Spirit.
                        </div>
                      </div>
                    </div>

                    <div
                      className="accordion-item"
                      data-aos="fade-up"
                      data-aos-duration="1800"
                    >
                      <h3 className="accordion-header" id="heading6">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse6"
                          aria-expanded="false"
                          aria-controls="collapse6"
                        >
                          Are you open for Partnerships?
                        </button>
                      </h3>
                      <div
                        id="collapse6"
                        className="accordion-collapse collapse"
                        aria-labelledby="heading6"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          Yes, feel free to open a ticket on our Discord and our
                          BD Team will contact you.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-3">
          <div className="container">
            <div className="row">
              <div
                className="col-md-12"
                data-aos="fade-up"
                data-aos-duration="1200"
              >
                <div className="d-flex justify-content-center gap-3 align-items-center">
                  <h4 className="lh">Audited by</h4>
                  <a
                    href="https://github.com/Quillhash/QuillAudit_Reports/blob/master/NovaDEX-CLMM%20Audit%20Report%20-%20QuillAudits.pdf"
                    target={'_blank'}
                    rel="noreferrer"
                  >
                    <img src="assets/QuillAudit.png" className="audit" alt="" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Home;
